import React, { Component } from 'react';
// import __ from 'lodash';
import { Row, Col } from 'react-bootstrap';

export default class ReportAgcuDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isLoading: false,
            isSearch: false,
        }
    }

    renderJudulMapel() {
        return (
            <thead>
                <th scope="col" style={{ textAlign: 'center' }}>NO</th>
                <th scope="col" style={{ textAlign: 'center' }}>SEKOLAH</th>
                <th scope="col" style={{ textAlign: 'center' }}>JUMLAH SISWA</th>
                {
                    this.props.dataMapel.map((val, index) => {
                        return (
                            <th scope="col" key={val.ID_MATA_PELAJARAN} data-attr-key={val.ID_MATA_PELAJARAN} style={{ textAlign: 'center' }}>{ val.NAMA_MATA_PELAJARAN }</th>
                        )
                    })
                }
                <th scope="col" style={{ textAlign: 'center' }}>RATA - RATA</th>
            </thead>
        )
    }

    renderIsiSekolah() {
        return (
            <tbody>
                {
                    this.props.sekolahDinas.map((itemDinas, indexDinas) => {
                        return (
                            <tr key={itemDinas.ID_SEKOLAH} data-attr-id-sekolah={itemDinas.ID_SEKOLAH}>
                                <td key={itemDinas.ID_SEKOLAH} data-attr-index={itemDinas + 1} style={{ textAlign: 'center' }}>{ indexDinas + 1 }</td>
                                <td key={itemDinas.ID_SEKOLAH} data-attr-nama-sekolah={itemDinas.NAMA_SEKOLAH}>{ itemDinas.NAMA_SEKOLAH }</td>
                                <td key={itemDinas.ID_SEKOLAH} data-attr-jumlah-siswa={itemDinas.JUMLAH_SISWA} style={{ textAlign: 'center' }}>{ parseInt(itemDinas.JUMLAH_SISWA) }</td>
                                {
                                    this.props.rataSekolah.map((itemSekolah, indexSekolah) => {
                                        if(itemDinas.ID_SEKOLAH === itemSekolah.ID_SEKOLAH) {
                                            return this.props.dataMapel.map((itemMapel, indexMapel) => {
                                                if(itemMapel.ID_MATA_PELAJARAN === itemSekolah.ID_MAPEL) {
                                                    return (    
                                                        <td key={itemDinas.ID_SEKOLAH} data-attr-idmapel={itemMapel.ID_MATA_PELAJARAN} style={{ textAlign: 'center' }}>{ parseFloat(itemSekolah.NILAI_RATA_RATA_MAPEL).toFixed(2) }</td>
                                                    )
                                                }
                                            });
                                        }
                                    })
                                }
                                {
                                    this.props.rataPerSekolah.map((itemPerSekolah, indexPerSekolah) => {
                                        if(itemDinas.ID_SEKOLAH === itemPerSekolah.ID_SEKOLAH) {
                                            return (
                                                <td key={itemDinas.ID_SEKOLAH} data-attr-idmapel={itemPerSekolah.ID_SEKOLAH} style={{ textAlign: 'center' }}>{ parseFloat(itemPerSekolah.NILAI_RATA_RATA_SEKOLAH).toFixed(2) }</td>
                                            )
                                        }
                                    })
                                }
                            </tr>
                        )
                    })
                }
            </tbody>
        )
        
    }

    renderJudulTable_2() {
        return (
            <thead>
                <tr>
                    <th scope="col" rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>STATISTIKA</th>
                    <th scope="col" colspan={ this.props.dataMapel.length } style={{ verticalAlign: 'inherit', textAlign: 'center' }}>MATA PELAJARAN</th>
                    <th scope="col" rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>RATA - RATA</th>
                </tr>
                <tr>
                    {
                        this.props.dataMapel.map(function(valMapel) {
                            return (
                                <th scope="col" key={valMapel.ID_MATA_PELAJARAN} data-attr-key={valMapel.ID_MATA_PELAJARAN} style={{ textAlign: 'center' }}>{ valMapel.NAMA_MATA_PELAJARAN }</th>
                            )
                        })
                    }
                </tr>
            </thead>
        );
    }

    renderTbodyTable_2() {
        let kategori;
        let nilai;

        const sumKategoriRata = this.props.rataStatistik.reduce((totalKategori, valRataStatistik) =>
            {
                if (valRataStatistik.kategori === 'BAIK') {
                    nilai = 3;
                }
                else if (valRataStatistik.kategori === 'CUKUP') {
                    nilai = 2;
                }
                else {
                    nilai = 1;
                }

                return totalKategori + parseFloat(nilai, 0)
            }
        , 0);

        console.groupCollapsed('CEK');
        console.info('SUM STRING', sumKategoriRata);
        console.info('RATA - RATA STRING', parseInt(sumKategoriRata / this.props.rataStatistik.length));
        console.groupEnd();

        const rataKategori = parseInt(sumKategoriRata / this.props.dataMapel.length);
        if (rataKategori === 3) {
            kategori = <td style={{ color: '#0d9400', textAlign: 'center' }}>BAIK</td>;
        }
        else if (rataKategori === 2) {
            kategori = <td style={{ color: '#ccc508', textAlign: 'center' }}>CUKUP</td>;
        }
        else {
            kategori = <td style={{ color: '#ff0000', textAlign: 'center' }}>KURANG</td>;
        }

        return (
            <tbody>
                <tr data-attr="kategori">
                    <td>KATEGORI</td>
                    {
                        this.props.rataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            if (valRataStatistik.kategori === 'BAIK') {
                                return (
                                    <td key={valRataStatistik.idMapel} style={{ color: '#0d9400', textAlign: 'center' }}>{ valRataStatistik.kategori }</td>
                                )
                            }
                            else if (valRataStatistik.kategori === 'CUKUP') {
                                return (
                                    <td key={valRataStatistik.idMapel} style={{ color: '#ccc508', textAlign: 'center' }}>{ valRataStatistik.kategori }</td>
                                )
                            }
                            else {
                                return (
                                    <td key={valRataStatistik.idMapel} style={{ color: '#ff0000', textAlign: 'center' }}>{ valRataStatistik.kategori }</td>
                                )
                            }
                        })
                    }
                    {kategori}
                </tr>
                <tr data-attr="rata-rata">
                    <td>RATA - RATA</td>
                    {
                        this.props.rataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.rataNilai).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.props.rataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.rataNilai, 0), 0) / this.props.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
                <tr data-attr="terendah">
                    <td>TERENDAH</td>
                    {
                        this.props.rataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.nilaiRendah).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.props.rataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.nilaiRendah, 0), 0) / this.props.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
                <tr data-attr="tertinggi">
                    <td>TERTINGGI</td>
                    {
                        this.props.rataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.nilaiAtas).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.props.rataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.nilaiAtas, 0), 0) / this.props.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
                <tr data-attr="standart-deviasi">
                    <td>STANDAR DEVIASI</td>
                    {
                        this.props.rataStatistik.map(function(valRataStatistik, indexRataStatistik) {
                            return (
                                <td key={valRataStatistik.idMapel} style={{ textAlign: 'center' }}>{ parseFloat(valRataStatistik.stDev).toFixed(2) }</td>
                            )
                        })
                    }
                    <td style={{ textAlign: 'center' }}>
                        {
                            (this.props.rataStatistik.reduce((totalCalories, valRataStatistik) => totalCalories + parseFloat(valRataStatistik.stDev, 0), 0) / this.props.dataMapel.length).toFixed(2)
                        }
                    </td>
                </tr>
            </tbody>
        )
    }

    renderTbodyTable_3() {
        return (
            <tbody>
                { 
                    this.props.sekolahDinas.map((dataDinas, indexDinas) => {
                        return (
                            <tr key={dataDinas.ID_SEKOLAH} data-attr-idSekolah={dataDinas.ID_SEKOLAH}>
                                <td style={{ textAlign: 'center' }}>{ indexDinas + 1 }</td>
                                <td>{ dataDinas.NAMA_SEKOLAH }</td>
                                <td style={{ textAlign: 'center' }}>{ parseInt(dataDinas.JUMLAH_SISWA) }</td>
                                {
                                    this.props.pemataanLS.map((dataLS, indexLS) => {
                                        if (dataLS.ID_SEKOLAH === dataDinas.ID_SEKOLAH ) {
                                            return (
                                                <>
                                                    <td style={{ textAlign: 'center' }}>{ parseInt(dataLS.VISUAL) }</td>
                                                    <td style={{ textAlign: 'center' }}>{ parseInt(dataLS.AUDITORI) }</td>
                                                    <td style={{ textAlign: 'center' }}>{ parseInt(dataLS.KINESTETIK) }</td>
                                                </>
                                            )
                                        }
                                    })
                                }
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    renderTheadTable_4() {
        return (
            <thead>
                <tr>
                    <th rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>NO</th>
                    <th rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>SEKOLAH</th>
                    <th rowspan="2" style={{ verticalAlign: 'inherit', textAlign: 'center' }}>JUMLAH SISWA</th>
                    <th colspan="3" style={{ textAlign: 'center' }}>ADVERSTY QUOTIENT</th>
                    <th colspan="3" style={{ textAlign: 'center' }}>EMOTIONAL QUOTIENT</th>
                    <th colspan="3" style={{ textAlign: 'center' }}>ACHIEVEMENT MOTIVATION</th>
                </tr>
                <tr>
                    <th style={{ textAlign: 'center' }}>RATA BAWAH</th>
                    <th style={{ textAlign: 'center' }}>RATA - RATA</th>
                    <th style={{ textAlign: 'center' }}>RATA - ATAS</th>
                    <th style={{ textAlign: 'center' }}>RATA BAWAH</th>
                    <th style={{ textAlign: 'center' }}>RATA - RATA</th>
                    <th style={{ textAlign: 'center' }}>RATA - ATAS</th>
                    <th style={{ textAlign: 'center' }}>RATA BAWAH</th>
                    <th style={{ textAlign: 'center' }}>RATA - RATA</th>
                    <th style={{ textAlign: 'center' }}>RATA - ATAS</th>
                </tr>
            </thead>
        )
    }

    renderTbodyTable_4() {
        return (
            <tbody>
                {
                    this.props.pemetaanPSI.map(function(valPSI, indexPSI) {
                        return (
                            <tr key={valPSI.ID_SEKOLAH} data-attr={valPSI.ID_SEKOLAH}>
                                <td style={{ textAlign: 'center' }}>{ indexPSI + 1 }</td>
                                <td>{ valPSI.NAMA_SEKOLAH }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.JUMLAH_SISWA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AQA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AQB }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AQT }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.EQA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AMA }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AMB }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.EQB }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.AMT }</td>
                                <td style={{ textAlign: 'center' }}>{ valPSI.EQT }</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    grapMapel() {
        return (
            <>
                {
                    this.props.rataStatistik.map((valRataStatistik, indexRataStatistik) => {
                        return (
                            <div className="row">
                                <Col sm={10} key={valRataStatistik.idMapel} data-attr={valRataStatistik.idMapel}>
                                    <div>{ valRataStatistik.namaMapel }</div>
                                    <div class="graph">
                                        <div class="skills background" style={{ width: parseFloat(valRataStatistik.rataNilai).toFixed(2) + '%' }}></div>
                                    </div>
                                </Col>

                                <Col sm={2}>
                                    <div>&nbsp;</div>
                                    <div>{ parseFloat(valRataStatistik.rataNilai).toFixed(2) + '%'}</div>
                                </Col>
                            </div>
                        )
                    })
                }
            </>
        )
    }

    grapSekolah() {
        return this.props.sekolahDinas.map((valDinas, indexDinas) => {
            return (
                <>
                    {
                        this.props.rataPerSekolah.map((valSekolah, indexSekolah) => {
                            if(valDinas.ID_SEKOLAH === valSekolah.ID_SEKOLAH) {
                                return (
                                    <div className="row">
                                        <Col sm={10} key={valSekolah.ID_SEKOLAH} data-attr={valSekolah.ID_SEKOLAH}>
                                            <div>{ valDinas.NAMA_SEKOLAH }</div>
                                            <div class="graph">
                                                <div class="skills background" style={{ width: parseFloat(valSekolah.NILAI_RATA_RATA_SEKOLAH).toFixed(2) + '%' }}></div>
                                            </div>
                                        </Col>

                                        <Col className="col-sm-2 col-sm-2" style={{ alignSelf: 'flex-end' }}>
                                            {/* <div>&nbsp;</div> */}
                                            <div className="center">{ parseFloat(valSekolah.NILAI_RATA_RATA_SEKOLAH).toFixed(2) + '%'}</div>
                                        </Col>
                                    </div>
                                );
                            }
                        })
                    }
                </>
            );
        });
    }

    render() {
        console.groupCollapsed('Render Cek State/Props ReportAgcuDetail');
        console.log('STATE', this.state);
        console.log('PROPS', this.props);
        console.groupEnd();

        const mystyle = {
            border: '3px solid grey',
            borderRadius: '1.50rem!important',
            margin: 'auto',
            width: '50%',
            height: '190px',
            textAlign: 'center',
        }

        return (
            <>
                {
                    this.props.dataMapel.length > 0 && this.props.sekolahDinas.length > 0 && this.props.rataSekolah.length > 0 && this.props.satuanPendidikan !== null &&
                    this.props.jumAllSiswa !== null && this.props.rataStatistik.length > 0 && this.props.pemataanLS.length > 0 && this.props.pemetaanPSI.length > 0 &&
                    this.props.pemetaanPSI.length > 0 && this.props.namaProfilCbt !== null
                    &&
                    <div id="dataToPrint">
                        {/*
                        <Row>
                            <Col sm>
                                <h5>{ this.props.namaDinas }</h5>
                            </Col>
                            
                            <Col sm>
                                <h5>{ this.props.namaProfilCbt }</h5>
                            </Col>
                            
                            <Col sm={2} className="no-print">
                                <button type="submit" className="btn btn-primary" onClick={this.handlePrint.bind(this)}>
                                    <i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp; Download
                                </button>
                            </Col>
                        </Row>
                        */}

                        <Row style={{ paddingTop: '15px' }}>
                            <Col sm={12}>
                                <h5 className="judul-h5">RATA - RATA NILAI MATA PELAJARAN SEKOLAH</h5>
                            </Col>

                            <Col sm={12}>
                                <table className="table table-striped">
                                    { this.renderJudulMapel() }

                                    { this.renderIsiSekolah() }
                                </table>
                            </Col>
                        </Row>

                        {/* <Row style={{ paddingTop: '15px' }}>
                            <Col sm={8}>
                                <h5 className="judul-h5">STATISTIK RATA - RATA NILAI MATA PELAJARAN</h5>
                            </Col>
                            <Col sm={4}>
                                <h5 className="judul-h5">GRAFIK RATA - RATA NILAI MATA PELAJARAN</h5>
                            </Col>

                            <Col sm={2}>SATUAN PENDIDIKAN</Col>
                            <Col sm={2}>{ parseInt(this.props.satuanPendidikan) }</Col>
                            <Col sm={4}>&nbsp;</Col>
                            <Col sm={4}>&nbsp;</Col>

                            <Col sm={2}>JUMLAH PESERTA</Col>
                            <Col sm={2}>{ parseInt(this.props.jumAllSiswa) }</Col>
                            <Col sm={4}>&nbsp;</Col>
                            <Col sm={4}>&nbsp;</Col>

                            <Col sm={8}>
                                <table className="table table-custom">
                                    { this.renderJudulTable_2() }

                                    { this.renderTbodyTable_2() }
                                </table>
                            </Col>

                            <Col sm={4}>
                                { this.grapMapel() }
                            </Col>
                        </Row>

                        <Row style={{ paddingTop: '15px' }}>
                            <Col sm={10}>
                                <h5 className="judul-h5">GRAFIK RATA - RATA NILAI MATA PELAJARAN PER SEKOLAH</h5>
                            </Col>
                            <Col sm={2}>
                                <h5 className="judul-h5 center">Nilai Rata - Rata</h5>
                            </Col>

                            <Col sm={12}>
                                { this.grapSekolah() }
                            </Col>
                        </Row>

                        <Row style={{ paddingTop: '15px' }}>
                            <Col sm={9}>
                                <h5 className="judul-h5">PEMETAAN GAYA BELAJAR PER SEKOLAH</h5>
                            </Col>

                            <Col sm={9}>
                                <table className="table table-custom">
                                    <thead>
                                        <th scope="col" style={{ textAlign: 'center' }}>NO</th>
                                        <th scope="col" style={{ textAlign: 'center' }}>SEKOLAH</th>
                                        <th scope="col" style={{ textAlign: 'center' }}>JUMLAH SISWA</th>
                                        <th scope="col" style={{ textAlign: 'center' }}>VISUAL</th>
                                        <th scope="col" style={{ textAlign: 'center' }}>AUDIO</th>
                                        <th scope="col" style={{ textAlign: 'center' }}>KINESTETIK</th>
                                    </thead>

                                    { this.renderTbodyTable_3() }
                                </table>
                            </Col>

                            <Col sm={3}>
                                <h5 className="judul-h5" style={{ textAlign: 'center' }}>DOMINASI</h5>
                                <div className="border rounded center" style={ mystyle }>{ this.props.dominasiLS }</div>
                            </Col>
                        </Row>

                        <Row style={{ paddingTop: '15px' }}>
                            <Col sm={12}>
                                <h5 className="judul-h5">PEMETAAN PSYCHOLOGI TEST</h5>
                            </Col>
        
                            <Col sm={12}>
                                <table className="table table-custom">
                                    { this.renderTheadTable_4() }
        
                                    { this.renderTbodyTable_4() }
                                </table>
                            </Col>
                        </Row> */}
                    
                        {/*
                        <Row style={{ paddingTop: '15px' }}>
                            <Col className="border rounded center" sm={3} style={ mystyle }>RATA - RATA</Col>
                            <Col className="border rounded center" sm={3} style={ mystyle }>RATA - RATA ATAS</Col>
                            <Col className="border rounded center" sm={3} style={ mystyle }>RATA - RATA BAWAH</Col>
                        </Row>

                        <Row style={{ paddingTop: '15px' }}>
                            <Col sm={3} className="center">ADVERSTY QUOTIENT</Col>
                            <Col sm={3} className="center">EMOTIONAL QUOTIENT</Col>
                            <Col sm={3} className="center">ACHIEVEMENT MOTIVATION</Col>
                        </Row>
                        */}
                    </div>
                }
            </>
        )
    }

    handlePrint = (event) => {
        event.preventDefault();
        console.groupCollapsed('handlePrint');
        console.info(event);
        console.info((document.getElementById("dataToPrint").innerHTML).parseT);
        console.groupEnd();
        
        // window.open("REPORT_DINAS_TOO", "PRINT", "height=400,width=600");
        const divContents = document.getElementById("dataToPrint").innerHTML; 
        const a = window.open();

        a.document.write('<html>');
        a.document.write('<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous"></link>');
        a.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons"></link>');
        a.document.write('<link rel="stylesheet" href="/custom.css" />');
        a.document.write('<link rel="stylesheet" href="/report-custom.css" />');
        a.document.write('<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/scss/_tables.scss" />');
        a.document.write('<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous"></link>');
        a.document.write('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/malihu-custom-scrollbar-plugin/3.1.5/jquery.mCustomScrollbar.min.css">');
        a.document.write('<script src="https://code.jquery.com/jquery-3.4.1.slim.min.js" integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n" crossorigin="anonymous"></script>');
        a.document.write('<script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js" integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo" crossorigin="anonymous"></script>');
        a.document.write('<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js" integrity="sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6" crossorigin="anonymous"></script>');
        a.document.write('<script src="https://cdnjs.cloudflare.com/ajax/libs/malihu-custom-scrollbar-plugin/3.1.5/jquery.mCustomScrollbar.concat.min.js"></script>');
        
        a.document.write('<body>');
        a.document.write(divContents);
        a.document.write('</body>');
        a.document.write('</html>');
        a.document.close(); 
        a.print();
    };
}